import React, { useState } from "react";
import PublicNavbar from "../../components/Navbars/PublicNavbar";
import AuthFooter from "../../components/Footers/AuthFooter";
import {
  Container,
  Col,
  Row,
  Table,
  UncontrolledButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { phoneEmailUrlClickCount } from "../../http/http-calls";
import { copyToClipboard, showToast } from "../../helper-methods";
import { BASE_URL } from "../../config";
import axios from "axios";
import Swal from "sweetalert2";

const ServiceList = () => {
  const location = useLocation();
  const [isDisabled, setIsDisabled] = useState(false);
  const [expandedRows, setExpandedRows] = useState([]);

  // console.log("searchList", location.state);

  const _emailPhoneUrlClickHandler = async (type, text) => {
    let newServiceArray = location.selectedServiceId;
    copyToClipboard(text);
    try {
      await phoneEmailUrlClickCount({
        clickType: type,
        service: newServiceArray,
      });
      // console.log("type", res);
      // showToast(
      //   res.message && res.message.length
      //     ? "Success"
      //     : "Provider Added Successfully!",
      //   "success"
      // );
    } catch (error) {
      // console.log("error", error);
      if (error.reason) {
        showToast(
          error.reason && error.reason.length
            ? error.reason
            : "Server error. Try again after sometime.",
          "error"
        );
      }
    }
  };

  const _exportListHandler = async (format) => {
    try {
      if (typeof window !== "undefined" && !isDisabled) {
        setIsDisabled(true);

        const outputFilename =
          format === "xlsx" ? "provider.xlsx" : "provider.pdf";

        const payload = {
          data: location?.state,
          format: format,
        };

        axios
          .post(`${BASE_URL}/download`, payload, {
            responseType: "arraybuffer",
            headers: {
              "Content-Type": "application/json",
            },
          })
          .then((response) => {
            const href = URL.createObjectURL(new Blob([response.data]));

            const link = document.createElement("a");
            link.href = href;
            link.setAttribute("download", outputFilename);
            document.body.appendChild(link);
            link.click();

            document.body.removeChild(link);
            URL.revokeObjectURL(href);
          })
          .catch((error) => {
            Swal.fire("Error", "Failed to download file", "warning");
          })
          .finally(() => {
            setIsDisabled(false);
          });
      }
    } catch (error) {
      Swal.fire("Error", error.message, "warning");
      setIsDisabled(false);
    }
  };

  const toggleRowExpansion = (index) => {
    setExpandedRows((prev) => {
      if (prev.includes(index)) {
        return prev.filter((i) => i !== index);
      } else {
        return [...prev, index];
      }
    });
  };

  return (
    <div className="vayco-admin public-protected">
      {/* //Protected Routes */}
      <div className="wrapper">
        <div className="main-panel">
          <PublicNavbar />
          <div className="content">
            <Container fluid className="mobilePadding-0">
              {/* ==== Page Header ===== */}
              <div className="page_Inner_header">
                <div className="page_title gap-2 justify-content-between">
                  <h1 className="space_remove">Your Resources List</h1>

                  {location?.state?.length ? (
                    <UncontrolledButtonDropdown>
                      <DropdownToggle
                        color="primary"
                        caret
                        disabled={isDisabled}
                      >
                        Export List
                      </DropdownToggle>
                      <DropdownMenu>
                        <DropdownItem onClick={() => _exportListHandler("pdf")}>
                          As PDF
                        </DropdownItem>
                        <DropdownItem
                          onClick={() => _exportListHandler("xlsx")}
                        >
                          As Excel
                        </DropdownItem>
                      </DropdownMenu>
                    </UncontrolledButtonDropdown>
                  ) : null}
                </div>
              </div>

              {/* ========= Table ======== */}
              <Table responsive className="check-switch m-0">
                <thead>
                  <tr>
                    <th>Company Name</th>
                    <th>Owner</th>
                    <th>Email</th>
                    <th>Phone</th>
                    <th>Address</th>
                    <th>Services</th>
                    <th>ZIP Codes</th>
                    <th>Non-Profit</th>
                    <th>
                      {/* style={{ textTransform: "none !important" }} */}
                      Charge for Services
                    </th>

                    <th>URL</th>
                  </tr>
                </thead>
                <tbody>
                  {location?.state?.length ? (
                    location?.state?.map((data, index) => (
                      <tr key={index}>
                        <td>
                          {data?.providerName === "CVSO" ? (
                            <img
                              className="tableImage"
                              src={require("../../assets/img/verified.png")}
                              alt="CVSO"
                            />
                          ) : null}
                          {data?.providerName}
                        </td>
                        <td>
                          {data?.contactName?.last === undefined
                            ? data?.contactName?.first
                            : data?.contactName?.first +
                              " " +
                              data?.contactName?.last}
                        </td>
                        <td
                          onClick={() =>
                            _emailPhoneUrlClickHandler(
                              "email",
                              data?.providerEmail
                            )
                          }
                        >
                          <a
                            href={`mailto: ${data?.providerEmail}`}
                            className="mr-1"
                          >
                            <i className="fas fa-envelope"></i>
                          </a>
                          {data?.providerEmail}
                        </td>
                        <td
                          onClick={() =>
                            _emailPhoneUrlClickHandler(
                              "phone",
                              data?.providerPhone
                            )
                          }
                        >
                          <a
                            href={`tel: ${data?.providerPhone}`}
                            className="mr-1"
                          >
                            <i className="fas fa-phone"></i>
                          </a>
                          {data?.providerPhone}
                        </td>
                        <td>{data?.providerAddress}</td>
                        <td>
                          {" "}
                          {data?._service
                            ?.map((item) => item.serviceName)
                            .join(", ")}
                        </td>
                        <td>
                          {expandedRows.includes(index)
                            ? data?.zipcode?.join(", ")
                            : data?.zipcode?.slice(0, 2).join(", ")}
                          {data?.zipcode.length > 2 && (
                            // eslint-disable-next-line jsx-a11y/anchor-is-valid
                            <a
                              style={{
                                cursor: "pointer",
                                marginLeft: "5px",
                              }}
                              onClick={() => toggleRowExpansion(index)}
                            >
                              {expandedRows.includes(index)
                                ? "See Less"
                                : "See More"}
                            </a>
                          )}
                        </td>
                        <td>{data?.isNonProfit ? "Yes" : "No"}</td>
                        <td>{data?.isChargeable ? "Yes" : "No"}</td>
                        <td
                        // onClick={() =>
                        //   _emailPhoneUrlClickHandler("url", data?._service)
                        // }
                        // onClick={() =>
                        //   history.push(`/${data?.providerWebsiteUrl}`)
                        // }
                        >
                          {data?.providerWebsiteUrl ? (
                            <a
                              href={
                                data?.providerWebsiteUrl.startsWith(
                                  "http://"
                                ) ||
                                data?.providerWebsiteUrl.startsWith("https://")
                                  ? data?.providerWebsiteUrl
                                  : `http://${data?.providerWebsiteUrl}`
                              }
                              rel="noreferrer"
                              target="_blank"
                              onClick={() =>
                                _emailPhoneUrlClickHandler(
                                  "url",
                                  data?.providerEmail
                                )
                              }
                            >
                              <i className="fas fa-home mr-1"></i>
                              {data?.providerWebsiteUrl}
                            </a>
                          ) : null}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={10}>
                        <div className="noData">
                          <img
                            src={require("../../assets/img/noData.svg").default}
                            alt="no data"
                          />
                          <p>There is no data to display</p>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>

              <div
                className="d-flex justify-content-sm-between align-items-start text-center mt-5 flex-wrap justify-content-center"
                style={{ gap: "15px" }}
              >
                <Link to="/service-selection" className="btn btn-secondary">
                  New Search
                </Link>
                {/* <a
                  rel="noreferrer"
                  className="btn-primary"
                  target="_blank"
                  href="https://www.in.gov/dva/idva-vet-connect/"
                >
                  Request More Info from IDVA
                </a> */}
              </div>
              {/* <p
                className="fs-14 mt-2 text-sm-right text-center"
                style={{ color: "#919191" }}
              >
                More info on how IDVA can help you
              </p> */}
            </Container>
          </div>
          <AuthFooter />
        </div>
      </div>
    </div>
  );
};

export default ServiceList;
